import { InputBase, InputAdornment, CircularProgress } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export const Search = ({
	searchData,
	searchText,
	handleChangeSearch,
	classes,
	clearSearch
}) => {
	return (
		<div className="orders-content-filter-left">
			<div className="orders-search-wrapper order-page">
				<InputBase
					id="search_script"
					name="searchScript"
					style={{ marginRight: '1px' }}
					variant="outlined"
					placeholder="Search Orders"
					size="small"
					onChange={handleChangeSearch}
					onKeyUp={e => searchData(e)}
					className={classes.searchbox}
					value={searchText}
					startAdornment={
						<InputAdornment position="start">
							<SearchIcon style={{ fontSize: "16px", color: "#394A64" }} />
						</InputAdornment>
					}
					endAdornment={
						<InputAdornment position="end">
							{
								searchText &&
									<CloseRoundedIcon style={{ fontSize: "16px", color: "#394A64", cursor: "pointer" }} onClick={() => clearSearch()} />
									}

						</InputAdornment>
					}
				/>
			</div>
		</div>
	)
}